export function copyToClipboard(textContent) {
  let hiddenTextArea = document.createElement('textarea');

  hiddenTextArea.value = textContent.trim();
  hiddenTextArea.setAttribute('readonly', '');
  hiddenTextArea.style.position = 'absolute';
  hiddenTextArea.style.left = '-9999px';
  document.body.appendChild(hiddenTextArea);

  hiddenTextArea.select();
  document.execCommand('copy');
  document.body.removeChild(hiddenTextArea);
}
